import axios from 'axios'

export const submitCommunity = (request_description: string) => {
  return axios.post('/community/submit', { request_description })
}
